export default __webpack_public_path__ + "static/media/add.28e2a19c.svg";